import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 33169DB7-00C0-42E0-8C2D-2F50902FA15F
 * name arrow-bottom-left-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-left-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomLeftThinIcon = createSvgIcon(<><path d="M12.07 19L9.24 16.18L19 6.42L17.58 5L7.82 14.76L5 11.94V19Z" /></>, 'ArrowBottomLeftThinIcon');
export default ArrowBottomLeftThinIcon